export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15235.8d21368c.jpg";